import { UserPreferenceChartColor } from '../../../Core/Users/models/user-app-preferences-chart-colors.model';
import { CheckboxOptionModel } from './checkbox-option.model';

export class ChartColorCheckboxOptionModel extends CheckboxOptionModel {
    userPreferenceColor: UserPreferenceChartColor;

    constructor(
        label: string,
        key: string,
        userPreferenceColor: UserPreferenceChartColor,
        disabled: boolean = false,
        tooltip?: string,
    ) {
        super(label, key, disabled, tooltip);

        this.userPreferenceColor = userPreferenceColor;
    }
}
